module.exports = __webpack_public_path__ + "static/media/gb-wls.94904119.svg";